import { render } from "./TheDashboardFooter.vue?vue&type=template&id=31238225&scoped=true&ts=true"
import script from "./TheDashboardFooter.vue?vue&type=script&lang=ts"
export * from "./TheDashboardFooter.vue?vue&type=script&lang=ts"

import "./TheDashboardFooter.vue?vue&type=style&index=0&id=31238225&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31238225"]])

export default __exports__